import {charcoal} from '../sass/base/_exports.sass';

export const DiagonalLinesIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 24;
  const height = 24;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="24" height="24" fill="url(#diagonalLines)" />
      <defs>
        <pattern id="diagonalLines" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_2292_47028" transform="scale(0.0104167)" />
        </pattern>
        <image
          id="image0_2292_47028"
          width="96"
          height="96"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACD0lEQVR4nO2Yva4OURhGl79Cc64FESEh4TbUKq1O1CjcgRCVxhXQKvR6d0AQRCP5VKc4fo49356ZZ5t3rWSaycx+dtbzZhcbRERERERERERE9ucU8BzYNT5PgZOdmVeAz415n4BLnXnngPd/WT9KdfnRApQfLED5wQKUHyzgNPCicWM74Anryv8IXOzMuwB8aMz70pk1iamTv7b8tSf/K3C9M68Z5Su/pnzwzP/1zL/amTeZUeVvfvIPUX5QPg2bU/7CKD+M8sMoP4zywyg/jPLDKD+M8sP8b3c755l2t3OtM29oti7/oPP/Rdn6sXMAvOlcYzGqyN91rrMIleQPV0A1+UMVUFH+MAVUlT9EAZXlxwuoLj9agPKDBSg/WIDygwUo/+hzrzNvEspXvvKVv7J82P59/hT5dzvz9sLJD03+IcoPyueYTSl/JZQfRvlhlB9G+WGUH0b5YZQfZo7rhVb5Za4X1kL5QSocOw9mWGMRqsjfzbDO7FSSP1wB1eQPVcAU+d/YhvxhCpgq/0Zn3ijyhyiggvz7x6wfpbr8aAHKDxag/GAByg8WUOFu59GEvJcz5DXj5P8u/+wMmU0o/+jzCuXXkA+e+VH5NG7MyV8Q5Qfl84+NKX8FlD8jJ/b4590f3v0AbgGvO/ZyBngGXG78/jHwsCMP4DZwp/Hbt8BN4HtnpoiIiIiIiIiIFOUn500vhI90VaQAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};
